<template lang="pug">
section
  .d-flex.row.flex-row.align-items-end(v-if="lwobjectives.length > 0")
    .col-12
      p.bg-warning.text-center
        | Debe cerrar o continuar los objetivos pendientes para seguir con la planificación semanal. 
  .d-flex.row.flex-row.align-items-end
    .col-12
      h2 
        i Objetivos Pendientes
  .d-flex.row.flex-row.align-items-start
    .col-7
      .card.ad_border1-secondary.rounded-xl
        h4.ad_text-primary
          i Objetivos semana anterior
        div(v-if="lwobjectives.length > 0")
          .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(lwobj, index) in lwobjectives" :id="'card-' + index")
            form
              .d-flex.row.form-group.align-items-end.mb-1
                .col.d-flex.flex-nowrap
                  label.mb-0
                    a.group-kpi(:id="'viaje' + index")
                      i.icon-letters.icon-letters__viaje.mr-1(v-if="lwobj._id.travel") V
                      i.icon-letters.icon-letters__producto.mr-1(v-if="lwobj._id.product") P
                      i.icon-letters.icon-letters__segmento.mr-1(v-if="lwobj._id.segment") S
                    b-tooltip(:target="'viaje' + index" , placement='top')
                      | {{lwobj._id.travel ? lwobj._id.travel.name : ""}}+{{lwobj._id.product ? lwobj._id.product.name : ""}}+{{lwobj._id.segment ? lwobj._id.segment.name : ""}}
                    
                    label.mb-0
                      i.icon-letters.icon-letters__negocio.mr-1 N
                      | {{lwobj._id.business_type.length > 0 ? lwobj._id.business_type[0].name : ''}}
                    
                .col-auto
                  .row
                    .d-flex.flex-column.col-auto.mb-0.ad_text-grayMedio.text-center
                      small.col.flex-row Registro
                      | {{ lwobj.objectives.length > 0  ? lwobj.objectives[0].businesspercentage : null}}%
                    .d-flex.flex-column.col-auto.mb-0.ad_text-grayMedio.justify-content-between
                      small.flex-row Meta
                      span.flex-row {{lwobj._id.business_type.length > 0 ? lwobj._id.business_type[0].goal : ''}}%
            .d-flex.row
              .col-12
                table.w-100.text-center.table-rounded-body
                  thead
                    tr
                      th
                      th.text-left Objetivo
                      th
                      th 
                      th Registro
                      th Meta
                      th
                  tbody
                    tr(v-for="(obj, i) in lwobj.objectives")
                      td
                        div.pr-0
                          span.num_circle.ad_bg-secondary {{i + 1}}
                      td.w-100.text-left
                        div
                          | {{obj.kpi.length > 0 ? obj.kpi[0].name : ''}}
                      td
                        div.px-0
                          span.ad_text-success.text-nowrap
                            | {{obj.date | WeekDuration}}&deg; sem
                      td
                        div.pr-0.justify-content-center.text-info
                          | {{obj.open ? "Libre" : ""}}
                      td
                        div
                          | {{obj.kpipercentage}}%
                      td
                        div
                          | {{obj.kpi.length > 0 ? obj.kpi[0].goal : ''}}%
                      td
                        div.px-2
                          a.no-decoration(title="Comentarios" @click="openObjDetail(obj._id)")
                            i.icono.icono-comentarios.ad_text-primary
                      td
                        div
                          a.btn.btn-secondary.px-2(title="Actualizar" @click.stop='openObjDetailUpdate(obj._id)')
                            | Actualizar
        .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-if="lwobjectives.length == 0")
          .col-12.text-center.rounded-lg.ad_bg-gray.pt-3
            p.muted No hay objetivos para esta semana

    .col-5.pl-0
      .card.ad_border1-secondary.rounded-xl
        h4.ad_text-primary
          i Objetivos semana actual
        .col-12.text-center.rounded-lg.ad_bg-gray.pt-3(v-show='continuedObjectives.length == 0')
          p.muted Aún no ha seleccionado objetivos para esta semana
        div(v-if="lwobjectives.length > 0")
          .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(co, index) in continuedObjectives")
            form
              .d-flex.row.form-group.align-items-start.mb-1
                .col.pr-0
                  label.mb-0
                    a.group-kpi(:id="'viajecont' + index")
                      i.icon-letters.icon-letters__viaje.mr-1(v-if="co._id.travel") V
                      i.icon-letters.icon-letters__producto.mr-1(v-if="co._id.product") P
                      i.icon-letters.icon-letters__segmento.mr-1(v-if="co._id.segment") S
                    b-tooltip(:target="'viajecont' + index" , placement='top')
                      | {{co._id.travel ? co._id.travel.name : ""}}+{{co._id.product ? co._id.product.name : ""}}+{{co._id.segment ? co._id.segment.name : ""}}
                    
                  label
                    i.icon-letters.icon-letters__negocio.mr-1 N
                    | {{co._id.business_type.length > 0 ? co._id.business_type[0].name : ''}}
                .col-auto
                  p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
                    sup Registro
                    span {{ co.objectives[0].businesspercentage }}%
                  p.d-inline-block.mb-0.ad_text-grayMedio
                    sup Meta
                    span {{co._id.business_type.length > 0 ? co._id.business_type[0].goal : ''}}%
            .d-flex.row
              .col-12
                table.w-100.text-center.table-rounded-body
                  thead
                    tr
                      th
                      th.text-left Objetivo
                      th
                      th 
                      th Registro
                      th Meta
                      th
                  tbody
                    tr(v-for="(currentwo, n) in co.objectives" :key="currentwo._id")
                      td
                        div.pr-0
                          span.num_circle.ad_bg-secondary {{n + 1}}
                      td.text-left
                        div.pl-2
                          | {{currentwo.kpi.length > 0 ? currentwo.kpi[0].name : ''}}
                      td
                        div.px-0
                          span.ad_text-success
                            | {{currentwo.date | WeekDuration}}&deg; sem
                      td
                        div.pr-0.justify-content-center.text-info
                          | {{currentwo.open ? "Libre" : ""}}
                      td
                        div.px-0
                          | {{currentwo.kpipercentage}}%
                      td
                        div.px-0
                          | {{currentwo.kpi.length > 0 ? currentwo.kpi[0].goal : ''}}%
                      td
                        div.px-0

                          a.no-decoration(title="Comentarios" @click.stop='openObjDetail(currentwo._id)')
                            i.icono.icono-comentarios.ad_text-primary

  v-navigation-drawer(v-model='drawer2', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Comentarios
    section.py-4.px-2.overflowy-auto
      .col.d-flex.flex-nowrap
        label
          a#viajeobjcoment(v-if="objective")
            i.icon-letters.icon-letters__viaje.mr-1(v-if="!objective.open") V
            i.icon-letters.icon-letters__producto.mr-1(v-if="!objective.open") P
            i.icon-letters.icon-letters__segmento.mr-1(v-if="!objective.open") S
          b-tooltip(target="viajeobjcoment" , placement='top')
            | {{(objective) ? objective.travel ? objective.travel.name : '' : ''}} + {{(objective) ? objective.product ? objective.product.name : '' : ''}} + {{(objective) ? objective.segment ? objective.segment.name : '' : ''}}
        label.ml-1
          i.icon-letters.icon-letters__negocio.mr-1 N
          | {{(objective) ? objective.business_type ? objective.business_type.name : '' : ''}}
      .row.align-items-end
        .col
          .col-12
            h4 
              i.icon-letters.icon-letters__kpi.mr-1 A
              | {{(objective) ? objective.kpi ? objective.kpi.name: '' : ''}}
        .col-auto.pr-5
          p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
            sup Registro
            span.ad_text-grayDark {{(objective) ? objective.kpi ? objective.kpi.goal : '' : ''}}%
          p.d-inline-block.mb-0.ad_text-grayMedio
            sup Meta
            span {{(objective) ? objective.kpipercentage : ''}}%
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(placeholder='Agregar comentario', rows='3', v-model="comment")
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer2 = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommentToObjective(objective._id)" )
            | Agregar comentario
            i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-3
          i Anteriores
        div(v-if="objective")
          .row.mb-3(v-for='comm in (objective.comments? objective.comments.slice().reverse(): [])')
            .col-4.pr-0
              p.font-weight-bold.m-0 {{comm.user}}
              small.d-block {{comm.date | DateFormat}}
              small.d-block {{comm.date | HourFormat}} hrs.
            .col-8.pl-0
              .dialog-box
                p {{comm.text}}

  v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Actualizar Objetivo
      section.py-4.px-2.overflowy-auto
        .col-12
          label
            a#objectivetravelname(v-if="objective")
              i.icon-letters.icon-letters__viaje.mr-1(v-if="!objective.open") V
              i.icon-letters.icon-letters__producto.mr-1(v-if="!objective.open") P
              i.icon-letters.icon-letters__segmento.mr-1(v-if="!objective.open") S
            b-tooltip(target="objectivetravelname" , placement='top')
              | {{(objective) ? objective.travel ? objective.travel.name : '' : ''}} + {{(objective) ? objective.product ? objective.product.name : '' : ''}} + {{(objective) ? objective.segment ? objective.segment.name : '' : ''}}
          label.ml-1
            a#objectivebussinessname
              i.icon-letters.icon-letters__negocio.mr-1 N
            b-tooltip(target="objectivebussinessname" , placement='top')
              | {{(objective) ? objective.business_type ? objective.business_type.name : '' : ''}}
          label.ml-1
            i.icon-letters.icon-letters__kpi.mr-1 A
            | {{(objective) ? objective.kpi ? objective.kpi.name : '' : ''}}
        .col-12.mt-4
          table.w-100
            tbody
              tr
                td.py-2 Meta
                td.ad_text-grayMedio {{objective ? objective.kpi ? objective.kpi.goal: '' : ''}}%
                td &nbsp;
                td Cumple
                td(valign="top")
                  c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="")
              tr
                td.py-2 Registro semana anterior
                td.ad_text-grayMedio {{objective ? objective.kpipercentage : ''}}%
                td &nbsp;
                td No cumple
                td(valign="top")
                  c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="")
              tr
                td.py-2 Registro KPI de adherencia actualizado
                td.py-2
                  .d-flex.col-3.pr-0.d-flex.align-items-stretch
                    .d-flex.ad_text-grayMedio.text-center.w-100
                      .input-refresh.d-flex.flex-row.align-items-center.ml-2
                        input(type="text" v-model="registroAdherencia")
                        | %
                        a#kpiadherencia
                          i.fas.fa-info-circle.ad_text-secondary.ml-1
                        b-tooltip(target="kpiadherencia" , placement='top')
                          | % de Cumplimiento del KPI de Adherencia obtenido la semana pasada seleccionado
                td &nbsp;
                td(colspan='2')
              tr
                td.py-2 Registro KPI de negocio actualizado
                td.py-2
                  .d-flex.col-3.pr-0.d-flex.align-items-stretch
                    .d-flex.ad_text-grayMedio.text-center.w-100
                      .input-refresh.d-flex.flex-row.align-items-center.ml-2
                        input(type="text" v-model="registroNegocio")
                        | %
                        a#kpinegocio
                          i.fas.fa-info-circle.ad_text-secondary.ml-1
                        b-tooltip(target="kpinegocio" , placement='top')
                          | % de Cumplimiento del KPI de negocio obtenido la semana pasada seleccionado
                td &nbsp;
                td(colspan='2')
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model="comment_update")
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="closeObjective(objective._id), objective.businesspercentage = registroNegocio")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cerrar objetivo
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="continueObjective(objective._id)")
              | Continuar objetivo
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Comentarios
          div(v-if="objective")
            .row.mb-3(v-for='comm in (objective.comments? objective.comments.slice().reverse(): [])')
              .col-4.pr-0
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{comm.date | DateFormat}}
                small.d-block {{comm.date | HourFormat}} hrs.
              .col-8.pl-0
                .dialog-box
                  p {{comm.text}}                        
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "PSPendientes",
  props: ["clickedNext", "currentStep"],
  components: {},
  data() {
    return {
      drawer: null,
      drawer2: null,
      drawerx: null,
      drawerx2: null,
      drawery: null,
      drawery2: null,
      drawerz: null,
      drawerz2: null,
      overlay: false,
      // lwobjectives: [],
      // currentWeekObjectives: [],
      // continuedObjectives: [],
      objective: null,
      moveobjetivo: false,
      comment: "",
      comment_update: "",
      moveobjetivox: true,
      moveobjetivoy: false,
      moveobjetivoz: true,
      user: {},
      plan: {},
      date: null,
      compromiso: true,
      problemas: true,
      otros: true,
      cumplimiento: null,
      registroAdherencia: 0,
      registroNegocio: 0,
      check: true
    };
  },
  methods: {
    ...mapActions("objective", [
      "getObjectiveById",
      "close",
      "addComment",
      "continue",
      "setLWObjects",
      "setContObjects",
      "getContObjByPlan",
      "updateBusiness"
    ]),
    ...mapActions("user", []),
    ...mapActions("plan", []),


    openObjDetail(id) {
      const vm = this;
      vm.getObjectiveById(id).then(
        () => {
          vm.objective = vm.$store.getters["objective/getObjective"];
          vm.drawer2 = !vm.drawer2;
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    openObjDetailUpdate(id) {
      const vm = this;
      const loading = vm.$toast.loading(
        "Abriendo ventana para actualizar objetivo"
      );
      vm.comment_update = "";
      vm.getObjectiveById(id).then(
        () => {
          vm.objective = vm.$store.getters["objective/getObjective"];
          vm.registroAdherencia = vm.objective.kpipercentage;
          vm.registroNegocio = vm.objective.businesspercentage;
          vm.drawer = !vm.drawer;
          loading.hide();
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    getComments(id) {
      const vm = this;
      vm.commentsById(id).then(
        () => {
          vm.comments = vm.$store.getters["objective/getComments"];
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    addCommentToObjective(id) {
      const vm = this;
      let comm = {
        user: vm.user.name,
        date: moment(),
        text: vm.comment
      };
      vm.addComment({
        id: id,
        comment: comm
      }).then(
        () => {
          vm.objective.comments.push(comm);
          vm.drawer2 = false;
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    continueObjective(id) {
      const vm = this;
      if (
        isNaN(vm.registroAdherencia) || isNaN(vm.registroNegocio) ||
        (vm.registroNegocio > 100 ||
        vm.registroNegocio < -100) ||
        (vm.registroAdherencia > 100 || vm.registroAdherencia < -100)
      ) {
        vm.$notify({
          type: "danger",
          title: "El KPI debe ser un numero entre -100 y 100",
          closeable: true,
          duration: 5000
        });
        return;
      }
      const loading = vm.$toast.loading("Actualizando objetivo...");
      let doc = {
        id,
        plan: vm.plan,
        kpi_percentage: vm.registroAdherencia,
        business_percentage: vm.registroNegocio
      };

      if (vm.comment_update != "") {
        let comm = {
          user: vm.user.name,
          date: moment(),
          text: vm.comment_update
        };
        doc.comment = comm;
      }

      vm.continue(doc).then(
        () => {
          this.check = true;
          for (let index in vm.lwobjectives) {
            for (let oindex in vm.lwobjectives[index].objectives) {
              if (vm.lwobjectives[index].objectives[oindex]._id == id) {
                vm.lwobjectives[index].objectives[oindex].kpipercentage =
                  vm.registroAdherencia;
                vm._addNewObject(
                  vm.lwobjectives[index].objectives[oindex],
                  index
                );
                vm.lwobjectives[index].objectives.splice(oindex, 1);
                loading.hide();
              }
            }
          }
          vm.setLWObjects(vm.lwobjectives).then(
            () => {
              vm.setLWObjects(vm.lwobjectives).then(
                () => {
                  vm.drawer = !vm.drawer;
                  vm.$notify({
                    type: "success",
                    title: "Notificación",
                    content: "Objetivo actualizado",
                    closeable: true,
                    duration: 5000
                  });
                },
                error => {
                  vm.$notify({
                    type: "danger",
                    title: "Notificación",
                    content: error.payload.message,
                    closeable: true,
                    duration: 5000
                  });
                }
              );
            },
            error => {
              vm.$notify({
                type: "danger",
                title: "Notificación",
                content: error.payload.message,
                closeable: true,
                duration: 5000
              });
            }
          );
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    closeObjective(id) {
      const vm = this;
      const loading = vm.$toast.loading("Cerrando objetivo...");
      let doc = {
        id,
        kpi_percentage: vm.registroAdherencia,
        business_percentage: vm.registroNegocio,
        closed: true
      };
      if (vm.cumplimiento) {
        doc.accomplished = vm.cumplimiento == "true" ? true : false;
      } else {
        loading.hide();
        return vm.$notify({
          type: "danger",
          title: "Notificación",
          content: "Debe marcar si se cumplio o no el objetivo",
          closeable: true,
          duration: 5000
        });
      }
      if (vm.comment_update != "") {
        let comm = {
          user: vm.user.name,
          date: moment(),
          text: vm.comment_update
        };
        doc.comment = comm;
      }
      vm.close(doc).then(
        () => {
            for (let index in vm.lwobjectives) {
              for (let oindex in vm.lwobjectives[index].objectives) {
                if (vm.lwobjectives[index].objectives[oindex]._id == id) {
                  const actual_percentage = +vm.lwobjectives[index].objectives[0]
                    .businesspercentage;
                  const obj = vm.lwobjectives[index].objectives[oindex];
                  vm.lwobjectives[index].objectives.splice(oindex, 1);
                  loading.hide();
                  const objectivesToUpdate = new Array();
                  let updateBiz = false;
                  let lwIndex = new Array();
                  for (let cindex in vm.continuedObjectives) {
                    if (obj.open) {
                      updateBiz = false;
                    } else if (vm.continuedObjectives[cindex]._id.travel.name ==
                        obj.travel.name &&
                      vm.continuedObjectives[cindex]._id.product.name ==
                        obj.product.name &&
                      vm.continuedObjectives[cindex]._id.segment.name ==
                        obj.segment.name &&
                      vm.continuedObjectives[cindex]._id.business_type[0].name ==
                        obj.business_type[0].name) {
                      if (actual_percentage != +vm.registroNegocio) {
                        vm.continuedObjectives[cindex].objectives.forEach(
                          objective => {
                            objectivesToUpdate.push(objective._id);
                          }
                        );
                        lwIndex.push(index);
                        updateBiz = true;
                      }
                    } else if (
                      vm.continuedObjectives[cindex]._id.travel[0].name ==
                        obj.travel.name &&
                      vm.continuedObjectives[cindex]._id.product[0].name ==
                        obj.product.name &&
                      vm.continuedObjectives[cindex]._id.segment[0].name ==
                        obj.segment.name &&
                      vm.continuedObjectives[cindex]._id.business_type[0].name ==
                        obj.business_type[0].name
                    ) {
                      if (actual_percentage != +vm.registroNegocio) {
                        vm.continuedObjectives[cindex].objectives.forEach(
                          objective => {
                            objectivesToUpdate.push(objective._id);
                          }
                        );
                        lwIndex.push(index);
                        updateBiz = true;
                      }
                    }
                  }

                  if (!obj.open) {
                    if (vm.lwobjectives[index]._id.travel.name ==
                        obj.travel.name &&
                      vm.lwobjectives[index]._id.product.name ==
                        obj.product.name &&
                      vm.lwobjectives[index]._id.segment.name ==
                        obj.segment.name &&
                      vm.lwobjectives[index]._id.business_type[0].name ==
                        obj.business_type[0].name) {
                      vm.lwobjectives[index].objectives.forEach(objective => {
                        objectivesToUpdate.push(objective._id);
                      });
                    } else if (
                      vm.lwobjectives[index]._id.travel[0].name ==
                        obj.travel.name &&
                      vm.lwobjectives[index]._id.product[0].name ==
                        obj.product.name &&
                      vm.lwobjectives[index]._id.segment[0].name ==
                        obj.segment.name &&
                      vm.lwobjectives[index]._id.business_type[0].name ==
                        obj.business_type[0].name
                    ) {
                      vm.lwobjectives[index].objectives.forEach(objective => {
                        objectivesToUpdate.push(objective._id);
                      });
                    }
                  }
                  updateBiz
                    ? vm
                        .updateBusiness({
                          ids: objectivesToUpdate,
                          business_percentage: vm.registroNegocio
                        })
                        .then(
                          () =>
                            (vm.lwobjectives[
                              lwIndex[0]
                            ].objectives[0].businesspercentage =
                              vm.registroNegocio)
                        )
                        .catch(error => console.log(error))
                    : null;
                }
              }
            }
          vm.setLWObjects(vm.lwobjectives).then(
            () => {
              vm.drawer = !vm.drawer;
              vm.$notify({
                type: "success",
                title: "Notificación",
                content: "Objetivo cerrado",
                closeable: true,
                duration: 5000
              });
            },
            error => {
              vm.$notify({
                type: "danger",
                title: "Notificación",
                content: error.payload.message,
                closeable: true,
                duration: 5000
              });
            }
          );
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    _addNewObject(obj, lwindex) {
      const vm = this;
      const objectivesToUpdate = new Array();
      let updateBiz = false;
      if (vm.continuedObjectives.length > 0) {
        let addnew = true;
        for (let index in vm.continuedObjectives) {
          // console.log("vm.continuedObjectives");
          // console.log(vm.continuedObjectives[index]);
          // console.log("obj");
          // console.log(obj);
          if (obj.open) {
            if (vm.continuedObjectives[index]._id.business_type.length > 0) {
              if (vm.continuedObjectives[index]._id.business_type[0].name ==
                  obj.business_type[0].name) {
                if (
                  +vm.lwobjectives[lwindex].objectives[0].businesspercentage !==
                  +vm.registroNegocio
                ) {
                  vm.continuedObjectives[index].objectives.forEach(objective => {
                    objectivesToUpdate.push(objective._id);
                  });
                  updateBiz = true;
                }
                addnew = false;
                vm.continuedObjectives[index].objectives.push(obj);
              }
            }
          } else if (vm.continuedObjectives[index]._id.travel) {
            if (vm.continuedObjectives[index]._id.travel.name ==
                obj.travel.name &&
              vm.continuedObjectives[index]._id.product.name ==
                obj.product.name &&
              vm.continuedObjectives[index]._id.segment.name ==
                obj.segment.name &&
              vm.continuedObjectives[index]._id.business_type[0].name ==
                obj.business_type[0].name) {

              if (
                +vm.lwobjectives[lwindex].objectives[0].businesspercentage !==
                +vm.registroNegocio
              ) {
                vm.continuedObjectives[index].objectives.forEach(objective => {
                  objectivesToUpdate.push(objective._id);
                });
                updateBiz = true;
              }
              addnew = false;
              vm.continuedObjectives[index].objectives.push(obj);
            }
          }
        }

        for (let index in vm.lwobjectives) {
          if (obj.open) {
            if (vm.lwobjectives[index]._id.business_type.length > 0) {
              if (vm.lwobjectives[index]._id.business_type[0].name ==
                  obj.business_type[0].name) {
                vm.lwobjectives[index].objectives.forEach(objective => {
                  objectivesToUpdate.push(objective._id);
                });
              }
            }
          } else if (vm.lwobjectives[index]._id.travel) {
            if (vm.lwobjectives[index]._id.travel.name == obj.travel.name &&
              vm.lwobjectives[index]._id.product.name == obj.product.name &&
              vm.lwobjectives[index]._id.segment.name == obj.segment.name &&
              vm.lwobjectives[index]._id.business_type[0].name ==
                obj.business_type[0].name) {
              vm.lwobjectives[index].objectives.forEach(objective => {
                objectivesToUpdate.push(objective._id);
              }); 
            }
          }
        }
        updateBiz
          ? vm
              .updateBusiness({
                ids: objectivesToUpdate,
                business_percentage: vm.registroNegocio
              })
              .then(
                () =>
                  (vm.lwobjectives[lwindex].objectives[0].businesspercentage =
                    vm.registroNegocio)
              )
          : null;
        if (addnew) {
          vm.continuedObjectives.push({
            _id: {
              travel: [obj.travel],
              product: [obj.product],
              segment: [obj.segment],
              business_type: [obj.business_type[0]]
            },
            objectives: [obj]
          });
        }
      } else {
        for (let index in vm.lwobjectives) {
          if (obj.open) {
            if (vm.lwobjectives[index]._id.business_type.length > 0) {
              console.log(vm.lwobjectives[index]._id.business_type);
              if (vm.lwobjectives[index]._id.business_type[0].name ==
                  obj.business_type[0].name) {
                if (
                  +vm.lwobjectives[index].objectives[0].businesspercentage !==
                  +vm.registroNegocio
                ) {
                  vm.lwobjectives[index].objectives.forEach(objective => {
                    objectivesToUpdate.push(objective._id);
                  });
                  updateBiz = true;
                }
                updateBiz
                  ? vm
                      .updateBusiness({
                        ids: objectivesToUpdate,
                        business_percentage: vm.registroNegocio
                      })
                      .then(
                        () =>
                          (vm.lwobjectives[
                            lwindex
                          ].objectives[0].businesspercentage = vm.registroNegocio)
                      )
                      .catch(error => console.log(error))
                  : null;
              }
            }
          } else {
            if (vm.lwobjectives[index]._id.travel) {
              if (vm.lwobjectives[index]._id.travel.name == obj.travel.name &&
              vm.lwobjectives[index]._id.product.name == obj.product.name &&
              vm.lwobjectives[index]._id.segment.name == obj.segment.name &&
              vm.lwobjectives[index]._id.business_type[0].name ==
                obj.business_type[0].name) {
                if (
                +vm.lwobjectives[index].objectives[0].businesspercentage !==
                +vm.registroNegocio
                ) {
                  vm.lwobjectives[index].objectives.forEach(objective => {
                    objectivesToUpdate.push(objective._id);
                  });
                  updateBiz = true;
                }
                updateBiz
                  ? vm
                      .updateBusiness({
                        ids: objectivesToUpdate,
                        business_percentage: vm.registroNegocio
                      })
                      .then(
                        () =>
                          (vm.lwobjectives[
                            lwindex
                          ].objectives[0].businesspercentage = vm.registroNegocio)
                      )
                      .catch(error => console.log(error))
                  : null;
              }
            }
          }
        }
        vm.continuedObjectives.push({
          _id: {
            travel: [obj.travel],
            product: [obj.product],
            segment: [obj.segment],
            business_type: [obj.business_type[0]]
          },
          objectives: [obj]
        });
      }
      vm.check = false;
    }
  },
  watch: {
    continuedObjectives: function() {
      const vm = this;
      if (
        (vm.lwobjectives.map((obj => obj.objectives.length)).reduce((prev, current)=>{
          return prev + current;
        }, 0) == 0) &&
        vm.plan.state.order == 0
      ) {
        this.$emit("can-continue", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    lwobjectives: function() {
      const vm = this;
      if (
        (vm.lwobjectives.length == 0 || vm.continuedObjectives.length > 0) &&
        vm.plan.state.order == 0
      ) {
        this.$emit("can-continue", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    moveobjetivoy: function() {
      if (this.moveobjetivoy === true) {
        this.$emit("can-continue", { value: true });
        this.$emit("completed-step", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    drawer: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      // console.log(this.$parent.overlay)
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawerx: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      // console.log(this.$parent.overlay)
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawery: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      // console.log(this.$parent.overlay)
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawer2: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    currentStep: function() {
      const vm = this;
      if (vm.lwobjectives.length == 0 || vm.continuedObjectives.length > 0) {
        this.$emit("can-continue", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    }
  },
  updated() {
    const vm = this;
    // vm.lwobjectives = vm.$store.getters['objective/getLWObjectives()']
    vm.plan = vm.$store.getters["plan/getPlan"];
    vm.user = vm.$store.getters["auth/getUserInfo"];
    if (vm.check) {
      vm.getContObjByPlan({
        id: vm.plan._id,
        continued: true,
        user: vm.user.id
      }).then(
        () => {
          // vm.continuedObjectives = vm.$store.getters['objective/getObjectives()']
          if (
            (vm.lwobjectives.map((obj => obj.objectives.length)).reduce((prev, current)=>{
            return prev + current;
          }, 0) == 0) &&
            vm.plan.state.order == 0
          ) {
            vm.check = false;
            this.$emit("can-continue", { value: true });
          } else {
            this.$emit("can-continue", { value: false });
          }
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    }
  },
  computed: {
    ...mapGetters("objective", {
      lwobjectives: "getLWObjectives",
      continuedObjectives: "getObjectives"
    })
  }
};
</script>

<style lang="stylus"></style>


// WEBPACK FOOTER //
// src/views/ps-pendientes.vue